import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import cache from './utils/cache'

// element库注册
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; 
Vue.use(ElementUI);

// 注册全局组件
import components from './components'   
Vue.use(components);

// 挂载到原型链
Vue.prototype.$cache  = cache

// 单独导出供非Vue环境使用
export { cache }

// 全局样式
import './assets/stylesheets/index.less'

// window.addEventListener('message', function (event) {
//   if(event.origin != 'http://192.168.201.129:3000') return 
//   console.log('接受',event)
//   localStorage.setItem('ms_username', event.data)
//   // document.cookie = "token=" + event.data;
//   // ElMessage.success("登录成功"); 
//   // router.push("/");
//   // this.window.open("http://192.168.201.129:3000/#/dashboard")
// }, false);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
